import Phaser from 'phaser';

export class Bullet extends Phaser.GameObjects.Rectangle {
  velocityX: number = 0;
  velocityY: number = 0;
  damage: number = 1;
  maxRange: number = 300;
  distanceTravelled: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 4, 4, 0xffff00);
    scene.add.existing(this);
    this.setDepth(30);
  }

  update(delta: number): void {
    const dt = delta / 1000;
    const dx = this.velocityX * dt;
    const dy = this.velocityY * dt;
    this.x += dx;
    this.y += dy;
    this.distanceTravelled += Math.sqrt(dx * dx + dy * dy);
  }

  hasExceededRange(): boolean {
    return this.distanceTravelled >= this.maxRange;
  }
}
